/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Flex,
  Link,
  Option,
  Select,
  Switch,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Checkbox,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from 'src/components/Common/ButtonTab';
import NotifyAdmin from 'src/components/FilterNotification/NotifyAdmin';
import NotifyUser from 'src/components/FilterNotification/NotifyUser';
import {
  EnableDisableStatus,
  ExchangeOnlinePolicyItem,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { PolicyModeEnum, PolicyTypeEnum } from '@Policy/utils/constants';
import {
  vsActionDataSelector,
  vsAdvancedOptionConfigSelector,
  vsAdvancedSettingsConfigSelector,
} from '@Policy/store/filters/malwareScanning';
import Actions from '../../Components/Actions';
import AdvancedOptionModal from '../../Components/AdvancedOptionModal';
import { useVsUnscannableFileOptions } from '../../hooks/malwareScanning';
import { FormLabel, TitleLabel } from '@Components/Common/FormComponent';
import { UnscannableFileOptionsModal } from '../../Components/UnscannableFileOptionsModal';
import AdvancedSettingsModal from '../../Components/AdvancedSettingsModal';

export const VsNotification = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state and action from store
  const ntfAdminIntervalNum = policySelector(
    (s) => s.tmVirusscans.notification.ntfAdminIntervalNum
  );
  const ntfAdminIntervalType = policySelector(
    (s) => s.tmVirusscans.notification.ntfAdminIntervalType
  );
  const ntfAdminMessage = policySelector(
    (s) => s.tmVirusscans.notification.ntfAdminMessage
  );
  const ntfAdminNotifySettingType = policySelector(
    (s) => s.tmVirusscans.notification.ntfAdminNotifySettingType
  );
  const ntfAdminSubject = policySelector(
    (s) => s.tmVirusscans.notification.ntfAdminSubject
  );
  const ntfEnableNotifyAdmin = policySelector(
    (s) => s.tmVirusscans.notification.ntfEnableNotifyAdmin
  );
  const ntfEnableNotifyRecipient = policySelector(
    (s) => s.tmVirusscans.notification.ntfEnableNotifyRecipient
  );
  const ntfInternalRecipientMessage = policySelector(
    (s) => s.tmVirusscans.notification.ntfInternalRecipientMessage
  );
  const ntfInternalRecipientSubject = policySelector(
    (s) => s.tmVirusscans.notification.ntfInternalRecipientSubject
  );
  const ntfToAccount = policySelector(
    (s) => s.tmVirusscans.notification.ntfToAccount
  );
  const ntfAdminOccurenceNum = policySelector(
    (s) => s.tmVirusscans.notification.ntfAdminOccurenceNum
  );
  const ntfRecipientGroupId = policySelector(
    (s) => s.tmVirusscans.notification.ntfRecipientGroupId
  );
  const ntfRecipientGroupEnabled = policySelector(
    (s) => s.tmVirusscans.notification.ntfRecipientGroupEnabled
  );
  const recipientGroups = contextSelector((s) => s.recipientGroups);
  const setVsNtfState = contextSelector((s) => s.setVsNtfState);
  // notify admin
  const handleNtfEnableAdminChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setVsNtfState({
        ntfEnableNotifyAdmin: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfAdminToAccountChange = useCallback((value: string) => {
    setVsNtfState({ ntfToAccount: value });
  }, []);
  const handleNtfAdminSubjectChange = useCallback((value: string) => {
    setVsNtfState({ ntfAdminSubject: value });
  }, []);
  const handleNtfAdminMessageChange = useCallback((value: string) => {
    setVsNtfState({ ntfAdminMessage: value });
  }, []);
  const handleNtfAdminNotifySettingTypeChange = useCallback((value: number) => {
    setVsNtfState({ ntfAdminNotifySettingType: value });
  }, []);
  const handleNtfAdminIntervalNumChange = useCallback((value: number) => {
    setVsNtfState({ ntfAdminIntervalNum: value });
  }, []);
  const handleNtfAdminIntervalTypeChange = useCallback((value: number) => {
    setVsNtfState({ ntfAdminIntervalType: value });
  }, []);
  const handleNtfAdminOccurenceNumChange = useCallback((value: number) => {
    setVsNtfState({ ntfAdminOccurenceNum: value });
  }, []);
  const handleNtfRecipientGroupIdChange = useCallback(
    (recipientGroupId: number) => {
      setVsNtfState({ ntfRecipientGroupId: recipientGroupId });
    },
    []
  );
  const handleNtfRecipientGroupEnabledChange = useCallback(
    (enabled: EnableDisableStatus) => {
      setVsNtfState({ ntfRecipientGroupEnabled: enabled });
    },
    []
  );
  // notify user
  const handleNtfEnableRecipientChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setVsNtfState({
        ntfEnableNotifyRecipient: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfInternalRecipientSubjectChange = useCallback(
    (value: string) => {
      setVsNtfState({ ntfInternalRecipientSubject: value });
    },
    []
  );
  const handleNtfInternalRecipientMessageChange = useCallback(
    (value: string) => {
      setVsNtfState({ ntfInternalRecipientMessage: value });
    },
    []
  );
  useWhyDidYouUpdate('MalwareScanning VsNotification', {
    ntfAdminIntervalNum,
    ntfAdminIntervalType,
    ntfAdminNotifySettingType,
    ntfAdminOccurenceNum,
    ntfAdminSubject,
    ntfEnableNotifyAdmin,
    ntfEnableNotifyRecipient,
    ntfInternalRecipientMessage,
    ntfInternalRecipientSubject,
    ntfToAccount,
    ntfAdminMessage,
    recipientGroups,
    ntfRecipientGroupId,
    ntfRecipientGroupEnabled,
  });
  return (
    <Tabs mt="24px">
      <TabList>
        <ButtonTab>{t('policy.notification.admin')}</ButtonTab>
        <ButtonTab>{t('policy.notification.user')}</ButtonTab>
      </TabList>
      <TabPanels py="24px">
        <TabPanel>
          <NotifyAdmin
            status={ntfEnableNotifyAdmin}
            toAccount={ntfToAccount}
            notifySettingType={ntfAdminNotifySettingType}
            subject={ntfAdminSubject}
            message={ntfAdminMessage}
            intervalNum={ntfAdminIntervalNum}
            intervalType={ntfAdminIntervalType}
            occurenceNum={ntfAdminOccurenceNum}
            recipientGroups={recipientGroups}
            recipientGroupId={ntfRecipientGroupId}
            recipientGroupEnabled={ntfRecipientGroupEnabled}
            setStatus={handleNtfEnableAdminChange}
            setToAccount={handleNtfAdminToAccountChange}
            setNotifySettingType={handleNtfAdminNotifySettingTypeChange}
            setSubject={handleNtfAdminSubjectChange}
            setMessage={handleNtfAdminMessageChange}
            setIntervalNum={handleNtfAdminIntervalNumChange}
            setIntervalType={handleNtfAdminIntervalTypeChange}
            setOccurenceNum={handleNtfAdminOccurenceNumChange}
            setRecipientGroupId={handleNtfRecipientGroupIdChange}
            setRecipientGroupEnabled={handleNtfRecipientGroupEnabledChange}
          />
        </TabPanel>
        <TabPanel>
          <NotifyUser
            status={ntfEnableNotifyRecipient}
            subject={ntfInternalRecipientSubject}
            message={ntfInternalRecipientMessage}
            setStatus={handleNtfEnableRecipientChange}
            setSubject={handleNtfInternalRecipientSubjectChange}
            setMessage={handleNtfInternalRecipientMessageChange}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
export const VsBasicAction = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  const vsActionType = policySelector((s) => s.tmVirusscans.vsActionType);
  const vsActiveActionNotifyType = policySelector(
    (s) => s.tmVirusscans.vsActiveActionNotifyType
  );
  const actionData = contextSelector(vsActionDataSelector, isEqual);
  const setVsState = contextSelector((s) => s.setVsState);
  const policyMode = policySelector((s) => s.policyMode);
  return (
    <Flex direction="column">
      <Flex alignItems="center" mb="12px">
        <FormLabel label={t('policy.label.action')} withColon />
        <Select
          value={vsActionType}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            setVsState({ vsActionType: Number(e.target.value) });
          }}
          width="300px"
        >
          <Option value={0}>{t('policy.action.trendRecommendActions')}</Option>
          <Option value={1}>{t('policy.action.customizedActions')}</Option>
        </Select>
      </Flex>
      {vsActionType === 1 ? (
        <Actions
          actionData={actionData}
          disabledAll={policyMode === PolicyModeEnum.DefaultMonitorPolicy}
        />
      ) : (
        <Flex alignItems="center" mb="12px">
          <FormLabel label={t('policy.label.notification')} />
          <Switch
            value={vsActiveActionNotifyType}
            checked={!!vsActiveActionNotifyType}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setVsState({
                vsActiveActionNotifyType: Number(e.target.checked),
              });
            }}
          />
        </Flex>
      )}
    </Flex>
  );
};
export const VsAdvancedAction = ({
  availableTokenShow,
  replaceFileNameShow,
}: {
  replaceFileNameShow: boolean;
  availableTokenShow: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const advancedOptionConfig = contextSelector(
    vsAdvancedOptionConfigSelector,
    isEqual
  );
  const policyType = policySelector((s) => s.policyType);
  const setVsState = contextSelector((s) => s.setVsState);
  // local state
  const [isVisible, setIsVisible] = React.useState<boolean>(false);
  // advanced optino
  const handleAdvancedOptionClose = useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAdvancedOptionSave = useCallback(
    ({
      replaceFileName,
      replaceText,
    }: {
      replaceFileName: string;
      replaceText: string;
    }) => {
      // save config
      setVsState({
        vsReplacementFileName: replaceFileName,
        vsReplacementText: replaceText,
      });
      // close the modal
      setIsVisible(false);
    },
    []
  );
  useWhyDidYouUpdate('MalwareScanning VsAdvancedAction', {
    advancedOptionConfig,
    isVisible,
  });
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advanced.title')}
      </Link>
      <AdvancedOptionModal
        replacementTextDesc={
          [
            PolicyTypeEnum.SharePoint,
            PolicyTypeEnum.OneDrive,
            PolicyTypeEnum.Box,
            PolicyTypeEnum.Dropbox,
            PolicyTypeEnum.GoogleDrive,
            PolicyTypeEnum.Teams,
          ].includes(policyType)
            ? t('policy.action.replaceAction.quarantineOrDelete.desc')
            : t('policy.action.replaceAction.desc')
        }
        availableTokenShow={availableTokenShow}
        replaceFileNameShow={replaceFileNameShow}
        isVisible={isVisible}
        onClose={handleAdvancedOptionClose}
        config={advancedOptionConfig}
        saveConfig={handleAdvancedOptionSave}
      />
    </>
  );
};

export const VsAdvancedSettings4Files = ({
  availableTokenShow,
}: {
  availableTokenShow: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const advancedSettingsConfig = contextSelector(
    vsAdvancedSettingsConfigSelector,
    isEqual
  );
  const setVsState = contextSelector((s) => s.setVsState);
  // local state
  const [isVisible, setIsVisible] = React.useState<boolean>(false);
  // advanced optino
  const handleAdvancedSettings4FilesClose = useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAdvancedSettingsSave = useCallback(
    (config: {
      secondActionEnabled: number;
      secondActionType: number;
      replaceFileTagContent: string;
      replaceText: string;
    }) => {
      // save config
      setVsState({
        vsSecondActionEnabled: config.secondActionEnabled,
        vsSecondActionType: config.secondActionType,
        vsFileTagContent: config.replaceFileTagContent,
        vsReplacementText: config.replaceText,
      });
      // close the modal
      setIsVisible(false);
    },
    []
  );
  useWhyDidYouUpdate('MalwareScanning VsAdvancedSettings4Files', {
    advancedSettingsConfig,
    isVisible,
  });
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advancedSettings.title')}
      </Link>
      <AdvancedSettingsModal
        availableTokenShow={availableTokenShow}
        isVisible={isVisible}
        onClose={handleAdvancedSettings4FilesClose}
        config={advancedSettingsConfig}
        saveConfig={handleAdvancedSettingsSave}
      />
    </>
  );
};

export const VsUnscannableFileOptions = () => {
  const { t } = useTranslation();
  const {
    isUnscannableFileOptionsVisible,
    setIsUnscannableFileOptionsVisible,
    handleUnscannableFileOptionsClose,
    setVsState,
    replaceFileName,
    replaceText,
    actionConfig,
  } = useVsUnscannableFileOptions();
  useWhyDidYouUpdate('MalwareScanning VsUnscannalbeFileOptions', {
    isUnscannableFileOptionsVisible,
  });
  return (
    <>
      <Link
        onClick={() =>
          setIsUnscannableFileOptionsVisible(!isUnscannableFileOptionsVisible)
        }
      >
        {t('policy.action.unScannale.options')}
      </Link>
      <UnscannableFileOptionsModal
        isVisible={isUnscannableFileOptionsVisible}
        onClose={handleUnscannableFileOptionsClose}
        saveConfig={setVsState}
        replaceFileName={replaceFileName}
        replaceText={replaceText}
        actionConfig={actionConfig}
      />
    </>
  );
};

function ActionNotification({
  advancedOptionShow = true,
  unscannableOptionShow = true,
  replaceFileNameShow = true,
  availableTokenShow = false,
  advancedSettings4FilesShow = false,
}: {
  advancedOptionShow?: boolean;
  unscannableOptionShow?: boolean;
  replaceFileNameShow?: boolean;
  availableTokenShow?: boolean;
  advancedSettings4FilesShow?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <TitleLabel title={t('policy.label.action')} mb="24px" />
          <VsBasicAction />
          {advancedOptionShow || unscannableOptionShow ? (
            <Flex mb="24px" mt="16px">
              {advancedOptionShow ? (
                <VsAdvancedAction
                  replaceFileNameShow={replaceFileNameShow}
                  availableTokenShow={availableTokenShow}
                />
              ) : null}
              {advancedSettings4FilesShow ? (
                <VsAdvancedSettings4Files
                  availableTokenShow={availableTokenShow}
                />
              ) : null}
              {unscannableOptionShow ? <VsUnscannableFileOptions /> : null}
            </Flex>
          ) : null}
          <TitleLabel title={t('policy.label.notification')} />
          <VsNotification />
        </Flex>
      </Box>
    </div>
  );
}

export default React.memo(ActionNotification);
